"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get NC_REDIS_GRACE_TTL () {
        return NC_REDIS_GRACE_TTL;
    },
    get NC_REDIS_TTL () {
        return NC_REDIS_TTL;
    },
    get NC_REDIS_TYPE () {
        return NC_REDIS_TYPE;
    },
    get getRedisURL () {
        return getRedisURL;
    }
});
var NC_REDIS_TYPE = /*#__PURE__*/ function(NC_REDIS_TYPE) {
    NC_REDIS_TYPE["CACHE"] = "CACHE";
    NC_REDIS_TYPE["JOB"] = "JOB";
    NC_REDIS_TYPE["THROTTLER"] = "THROTTLER";
    return NC_REDIS_TYPE;
}({});
const NC_REDIS_TTL = +process.env.NC_REDIS_TTL || 60 * 60 * 24 * 3; // 3 days
const NC_REDIS_GRACE_TTL = +process.env.NC_REDIS_GRACE_TTL || 60 * 60 * 24 * 1; // 1 day
const getRedisURL = (type)=>{
    switch(type){
        case "CACHE":
            return process.env.NC_REDIS_URL;
        case "JOB":
            return process.env.NC_REDIS_JOB_URL;
        case "THROTTLER":
            return process.env.NC_THROTTLER_REDIS;
        default:
            return process.env.NC_REDIS_URL;
    }
};
